// @flow
function isMobile(): boolean {
    return window.innerWidth < 768;
}

export { isMobile };
